/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioMilestoneReachedNotificationPayloadDto
 */
export interface PortfolioMilestoneReachedNotificationPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof PortfolioMilestoneReachedNotificationPayloadDto
     */
    currencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioMilestoneReachedNotificationPayloadDto
     */
    milestoneValue: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioMilestoneReachedNotificationPayloadDto
     */
    currentValue: number;
}

export function PortfolioMilestoneReachedNotificationPayloadDtoFromJSON(json: any): PortfolioMilestoneReachedNotificationPayloadDto {
    return PortfolioMilestoneReachedNotificationPayloadDtoFromJSONTyped(json, false);
}

export function PortfolioMilestoneReachedNotificationPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioMilestoneReachedNotificationPayloadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'],
        'milestoneValue': json['milestoneValue'],
        'currentValue': json['currentValue'],
    };
}

export function PortfolioMilestoneReachedNotificationPayloadDtoToJSON(value?: PortfolioMilestoneReachedNotificationPayloadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currencyCode': value.currencyCode,
        'milestoneValue': value.milestoneValue,
        'currentValue': value.currentValue,
    };
}

